import { apiClient } from '@shared/api/apiClient.js';
import type {
  ListDomainsResponse,
  CreateDomainRequest,
  CreateDomainResponse,
  VerifyDomainResponse,
  SiteResolveResult,
} from '@shared/api/contracts/domains.js';

export function fetchDomains(signal?: AbortSignal): Promise<ListDomainsResponse> {
  return apiClient.get<ListDomainsResponse>('/domains', signal);
}

export function createDomain(body: CreateDomainRequest): Promise<CreateDomainResponse> {
  return apiClient.post<CreateDomainResponse>('/domains', body);
}

export function verifyDomain(id: string): Promise<VerifyDomainResponse> {
  return apiClient.post<VerifyDomainResponse>(`/domains/${id}/verify`);
}

export function deleteDomain(id: string): Promise<void> {
  return apiClient.delete<void>(`/domains/${id}`);
}

/** Resolve the current host to its tenant/league context.
 *  Called at app bootstrap when the hostname isn't the canonical one. */
export function fetchSiteResolve(signal?: AbortSignal): Promise<SiteResolveResult> {
  return apiClient.get<SiteResolveResult>('/site/resolve', signal);
}
